import { Inbox, Mail } from 'lucide-react';

import { EmptyBlock } from '@/components/ui/empty-block';
import { Button } from '@/components/ui/button';
import env from 'env';

const EmptyInvoices = () => {
  const onContactSupport = () => window.open(`mailto:${env.CODEKEEPER_SERVICE_EMAIL}`, '_blank');

  return (
    <EmptyBlock
      title="No invoices yet."
      description="It looks like you haven’t received any invoices yet. If you believe this is an error, please reach out to our support team."
      icon={Inbox}
      action={
        <Button onClick={onContactSupport}>
          <Mail />
          Contact us
        </Button>
      }
    />
  );
};

export default EmptyInvoices;
